export const statusPedido = {
    ABERTO: { estilo: 'info', texto: 'ABERTO' },
    CONFIRMADO: { estilo: "success", texto: 'CONFIRMADO' },
    CANCELADO: { estilo: 'danger', texto: 'CANCELADO' },
    CONTRATO_ASSINADO: { estilo: "success", texto: "Contrato Assinado" },
    PRONTO_PARA_PRODUCAO: { estilo: "info", texto: "Pronto para Produção" },
    EM_PRODUCAO: { estilo: "info", texto: "Em Produção" },
    ABERTO: { estilo: 'info', texto: 'Aberto' },
    CONFIRMADO: { estilo: "success", texto: 'Confirmado' },
    CANCELADO: { estilo: 'danger', texto: 'Cancelado' },
    CONTRATO_ASSINADO: { estilo: "success", texto: "Aceito" },
    EM_PRODUCAO: { estilo: "info", texto: "Aceito" },
    PRODUZIDO: { estilo: "warning", texto: "Produzido" },
    PRONTO_PARA_ENVIO: { estilo: "warning", texto: "Pronto para o envio" },
    ENVIADO: { estilo: "warning", texto: "Enviado" },
    ENTREGUE: { estilo: "warning", texto: "Entregue" },
    FINALIZADO: { estilo: "success", texto: "Finalizado" },
    PAGO: { estilo: "success", texto: "Pago" }
};

// Sequência de status do pedido
const sequenciaStatus = [
    'ABERTO',
    // 'CONTRATO_ASSINADO',
    'PRONTO_PARA_PRODUCAO',
    'EM_PRODUCAO',
    'PRODUZIDO',
    'PRONTO_PARA_ENVIO',
    'ENVIADO',
    'ENTREGUE',
    'FINALIZADO'
];

// Função para obter o próximo status e texto do botão
export const getProximoStatus = (statusAtual) => {
    const indexAtual = sequenciaStatus.indexOf(statusAtual);
    
    if (indexAtual === -1 || indexAtual === sequenciaStatus.length - 1) {
        return null; // Status inválido ou já está no último status
    }
    
    const proximoStatus = sequenciaStatus[indexAtual + 1];
    const textosBotao = {
        // 'CONTRATO_ASSINADO': 'Marcar como Pronto para Produção',
        'ABERTO': 'Produzir',
        'PRONTO_PARA_PRODUCAO': 'Iniciar Produção',
        'EM_PRODUCAO': 'Marcar como Produzido',
        'PRODUZIDO': 'Marcar como Pronto para Envio',
        'PRONTO_PARA_ENVIO': 'Marcar como Enviado',
        'ENVIADO': 'Marcar como Entregue',
        'ENTREGUE': 'Finalizar Pedido',
        'FINALIZADO': null
    };
    
    return {
        proximoStatus,
        textoBotao: textosBotao[statusAtual] || 'Avançar Status'
    };
};

export const pagamentoTipo = {
    cartaoCredito: 'Cartão de Crédito',
    cartaoDebito: 'Cartão de Débito',
    pix: "PIX",
    dinheiro: "Dinheiro",
};

export const paymentIcons = {
    cartaoCredito: 'iconoir:credit-card',
    cartaoDebito: 'iconoir:credit-card',
    pix: 'iconoir:scan-qr-code',           // ou: 'iconoir:qr-code'
    dinheiro: 'iconoir:money-square',
  };


export const statusPedidoNome = {
    // OPEN: "Criando... ", 
    ABERTO: "Em aberto", 
    CONTRATO_ASSINADO: "Contrato assinado",
    PRONTO_PARA_PRODUCAO: "Pronto para produção",

    // Etapa 2 - Produção
    EM_PRODUCAO: "Em produção",
    PRODUZIDO: "Produzido",

    // Etapa 3 - Expedição
    PRONTO_PARA_ENVIO: "Pronto para o envio",
    ENVIADO: "Enviado",

    // Etapa 4 - Pós-Venda
    ENTREGUE: "Entregue",
    FINALIZADO: "Finalizado",

    // Status de cancelamento
    CANCELADO: "Cancelado", 
    PAGO: "Pagamento confirmado"
}